<template>
  <footer class="site-footer">
    <div class="footer-bar">
      <span>© 2024-2026 快捷工具箱</span>
      <span><i class="el-icon-time" /> 已稳定运行 {{ uptimeDays }} 天</span>
      <span><i class="el-icon-view" /> 累计访问 {{ status.totalVisits }} 次</span>
    </div>
  </footer>
</template>

<script>
import { querySystemStatus, recordSiteVisit } from '../api/system'

export default {
  name: 'SiteFooter',
  data() {
    return {
      status: {
        totalVisits: '-',
        uptimeSeconds: 0
      },
      refreshTimer: null
    }
  },
  computed: {
    uptimeDays() {
      return Math.floor(Number(this.status.uptimeSeconds || 0) / 86400)
    }
  },
  mounted() {
    this.registerVisit()
    // 每 30 秒刷新一次统计数据
    this.refreshTimer = setInterval(this.loadSystemStatus, 30000)
  },
  beforeDestroy() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
      this.refreshTimer = null
    }
  },
  methods: {
    async registerVisit() {
      try {
        const { data } = await recordSiteVisit()
        this.applySystemStatus(data)
      } catch (error) {
        await this.loadSystemStatus()
      }
    },
    async loadSystemStatus() {
      try {
        const { data } = await querySystemStatus()
        this.applySystemStatus(data)
      } catch (error) {
        /* 接口异常时保留上次数据即可 */ }
    },
    applySystemStatus(data) {
      if (!data || data.code !== 200 || !data.data) return
      this.status.totalVisits = data.data.totalVisits
      this.status.uptimeSeconds = data.data.uptimeSeconds
    }
  }
}
</script>

<style scoped>
.site-footer { border-top: 1px solid var(--line); }
.footer-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px 32px;
  max-width: 1280px;
  margin: 0 auto;
  padding: 28px 32px;
  color: var(--ink-2);
  font-size: 13px;
}
.footer-bar span { display: inline-flex; align-items: center; gap: 6px; }
.footer-bar i { color: var(--ink-3); font-size: 14px; }
</style>
